import { Button } from '@material-ui/core';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import usePost from '../../hooks/usePost';
import useSpots from '../../hooks/useSpots';
import Navbar from '../Shared/Navbar';
import logoW from '../../assets/tripaide-logo-w.svg';
import axios from 'axios';
import { toInteger } from 'lodash';

const NewPost = () => {

    let navigate = useNavigate();
    const { id } = useParams();
    const [post] = usePost(id);
    const [spots] = useSpots();

    //console.log(id);
    //console.log(post);

    const spot = spots?.find(s => s?.district === post?.spot);

    const handleUpdatedPost = async (updatedPost) => {
        await axios.put("https://tripaide-server.onrender.com/posts", updatedPost)
            .then(res => {
                //console.log(res.data);
                navigate(`/dashboard`);
            });
    };

    const handleUpdatePost = (e) => {
        e.preventDefault();
        const updatedData = {
            id: id,
            place: e.target.place.value,
            member: toInteger(e.target.member.value),
            days: toInteger(e.target.days.value),
            budget: toInteger(e.target.budget.value),
            time: e.target.time.value,
            type: e.target.type.value,
            text: e.target.text.value,
            state: "Running"
        };

        //console.log(updatedData);

        handleUpdatedPost(updatedData);
    }

    return (
        <div>
            <Navbar />
            <div className='w-11/12 mx-auto my-8 lg:flex lg:items-center'>
                <div className='w-11/12 my-8 mx-auto lg:w-1/2 p-4'>
                    <div className='flex flex-col justify-center px-8 py-16 rounded-lg login-bg text-center text-white'>
                        <div className='flex flex-col items-center'>
                            <img className='block w-1/2' src={logoW} alt="main logo" />
                            <p>A Social Media From Travellers</p>
                        </div>
                        <div className='py-8 flex flex-col items-center'>
                            <p className='text-lg font-semibold'>Nice to see you again!</p>
                            <h1 className='text-2xl md:text-4xl font-bold'>Find Yo<span className='border-b-4'>ur To</span>urmates</h1>
                            <p className='mt-8 lg:mt-16 xl:w-3/5'>What's the fun in travelling alone? Let's find your perfect tour partners, guides, packages and many more!</p>
                        </div>
                    </div>
                </div>
                <div className='w-11/12 my-8 mx-auto lg:w-1/2 p-4'>
                    <form onSubmit={handleUpdatePost} className='border-2 rounded-lg p-4'>
                        <h1 className='text-2xl font-semibold text-yellow-500'>Please Fill Up Post Details</h1>
                        <h3 className='text-lg my-4'>Going to: <span className='font-semibold'>{spot?.district}</span></h3>
                        <h3 className='text-lg my-4'>Departue: <span className='font-semibold'>{post?.date}</span></h3>
                        <div className='text-lg my-4 flex items-center'>
                            <h2 className='mr-2'>Time: </h2>
                            <input type="time" name="time" id="time" required className='border-2 rounded-lg px-4 py-1' />
                        </div>
                        <div className='text-lg my-4 flex items-center'>
                            <h2 className='mr-2'>Place: </h2>
                            <select id="place" name="place" required className='border-2 rounded-lg px-4 py-1'>
                                {
                                    spot?.places.map(p =>
                                        <option key={p.name} value={p.name}>{p.name}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className='text-lg my-4 flex items-center'>
                            <h2 className='mr-2'>Group of: </h2>
                            <input type="number" name="member" id="member" min='0' required className='border-2 rounded-lg px-4 py-1' />
                        </div>
                        <div className='text-lg my-4 flex items-center'>
                            <h2 className='mr-2'>How many days? </h2>
                            <input type="number" name="days" id="days" min='0' required className='border-2 rounded-lg px-4 py-1' />
                        </div>
                        <div className='text-lg my-4 flex items-center'>
                            <h2 className='mr-2'>Budget <span className='text-sm'>(per person)</span>: </h2>
                            <input type="number" name="budget" id="budget" min='0' required className='border-2 rounded-lg px-4 py-1' />
                        </div>
                        <div className='text-lg my-4 flex items-center'>
                            <h2 className='mr-2'>Tour Type: </h2>
                            <select id="type" name="type" required className='border-2 rounded-lg px-4 py-1'>
                                <option value="Premium">Premium</option>
                                <option value="Economic">Economic</option>
                                <option value="Budget">Budget</option>
                            </select>
                        </div>
                        <div className='text-lg my-4'>
                            <h2 className='mr-2'>Additional Description</h2>
                            <textarea name="text" id="text" minLength="10" className='border-2 rounded-lg px-4 py-1'></textarea>
                        </div>
                        <Button type='submit' className='bg-yellow-500 text-lg font-medium' variant="contained">Update</Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NewPost;